<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">

    <kim-vue ref="kim"></kim-vue>

    <button @click="addFriend">添加好友到面板</button>
    <button @click="removeFriend">从面板移除好友</button>
    <button @click="getAnlan">获取安澜</button>
    <button @click="changeState(0)">安澜下线</button>
    <button @click="changeState(1)">安澜上线</button>
    <br><br>
    <button @click="customChat">自定义聊天窗口</button>

  </div>
</template>

<script>

import kimmain from "@/kim";

let kim = kimmain;
export default {
  name: 'App',
  components: {

  },
  mounted(){
    kim = this.$refs.kim;
    /*kim.config({
      members: {
        url:'http://res.itsub.cn/json/kim.members.json',
      }
    })*/


    $.get('http://res.itsub.cn/json/kim.init.json',function(res){
      if (res.code == 0) {
        kim.init({
          mine:res.mine,
          friends:res.friends,
          groups:res.groups,
        });
      }
    });

    kim.config({
      states:['在线','隐身','忙碌']
    })

  },
  methods:{
    addFriend() {
      kim.addContact({
        type:'friend',
        gid:2,    //好友分组
        id:1500,  //好友id
        name:'蔡文姬',//好友昵称
        avatar:'https://game.gtimg.cn/images/yxzj/img201606/heroimg/184/184.jpg',//好友头像
        sign:'飞舞战场的美少女,大活跃Q～～',
      })
    },
    removeFriend() {
      kim.removeFriend(1500);
    },
    //更改好友在线状态
    changeState(st) {
      kim.setFriendState(1003, st);
    },
    //获取1003号好友信息
    getAnlan() {
      console.log(kim.getFriend(1003))
      kim.on('sendMessage',function(res){
        var mine = res.mine;            //当前用户
        var to = res.to;                //接收者
        var content = res.content;      //发送内容
        //mine{ id,name,avatar }
        //to{ type,id,name,avatar }
      })
    },

    customChat() {
      kim.chat({
        name: '在线客服二' ,//名称
        type: 'kefu', //聊天类型
        avatar: 'https://game.gtimg.cn/images/yxzj/img201606/heroimg/152/152.jpg', //头像
        id: 16, //定义唯一的id方便你处理信息
      });
    },

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin-top: 60px;
}
</style>
